import React, { Component, PropTypes } from 'react';
import './Weedle.scss';

class Weedle extends Component {
  render() {
    return (
      <div className="pokemon">
        <div className="weedle">
          <div className="head">

          </div>
          <div className="body">

          </div>
        </div>
      </div>
    );
  }
}

export default Weedle;



/** WEBPACK FOOTER **
 ** ./source/013-weedle/Weedle.js
 **/